import { Button, Icon, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";
import { CSSProperties } from "styled-components";

import { UserAction } from "../../api";
import { useAuth } from "../../contexts";
import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales/ETLCodes";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IAddButtonProps extends ICustomButtonProps {
  actions?: UserAction[];
  style?: CSSProperties;
  icon?: React.ReactElement;
}

export const AddButton: React.FunctionComponent<IAddButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
  hideText,
  actions,
  style,
  icon,
}) => {
  const { t } = useTl();
  const { hasAction } = useAuth();

  return (
    <div>
      {!actions || hasAction(actions) ? (
        <Button
          icon={icon ?? <Icon icon={IconNames.PLUS} />}
          style={style}
          minimal={minimal}
          onClick={onClick}
          text={!hideText ? text || t(ETLCodes.Add) : null}
          intent={intent}
          loading={loading}
          disabled={disabled}
        />
      ) : null}
    </div>
  );
};
